import { format, parseISO, isBefore, startOfDay } from "date-fns";
import { fr } from "date-fns/locale";

export const ETAPES = [
  { id: "nouveau", label: "Nouveau", color: "#2563EB" },
  { id: "premier_echange", label: "Premier échange", color: "#7C3AED" },
  { id: "proposition_envoyee", label: "Proposition envoyée", color: "#9C8535" },
  { id: "mission_signee", label: "Mission signée", color: "#0F8A5F" },
  { id: "perdu", label: "Perdu", color: "#B42318" },
];
export const BESOINS = ["Audit", "Gestion de projet", "Stratégie marketing"];
export const ORIGINES = ["Site web", "Bouche-à-oreille", "Recommandation client", "Réseaux sociaux", "Salon / événement", "Prospection", "Autre"];
export const TAILLES = ["Micro-entreprise", "TPE", "PME"];
export const TYPES_ECHANGE = ["Appel", "Email", "Réunion", "Visio", "Document envoyé"];
export const STATUTS_MISSION = [
  { id: "en_cours", label: "En cours" },
  { id: "en_pause", label: "En pause" },
  { id: "terminee", label: "Terminée" },
];

export const etapeOf = (id) => ETAPES.find((e) => e.id === id) || ETAPES[0];
export const statutLabel = (id) => STATUTS_MISSION.find((s) => s.id === id)?.label || id;

export const toDate = (v) => (v ? parseISO(v) : null);
export const fmtDate = (v, f = "d MMM yyyy") => (v ? format(parseISO(v), f, { locale: fr }) : "—");
export const fmtEUR = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);
export const isOverdue = (v) => !!v && isBefore(parseISO(v), new Date());
export const isPastDay = (v) => !!v && isBefore(parseISO(v), startOfDay(new Date()));

export const nextDeadline = (m) =>
  (m.livrables || [])
    .filter((l) => !l.fait && l.echeance)
    .sort((a, b) => a.echeance.localeCompare(b.echeance))[0];

export const progress = (m) => {
  const total = (m.livrables || []).length;
  return total ? Math.round(((m.livrables.filter((l) => l.fait).length) / total) * 100) : 0;
};

export const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-");

export const relanceMailto = (c) => {
  const besoins = c.besoins?.length ? c.besoins.join(", ").toLowerCase() : "accompagnement";
  const prop = c.etape === "proposition_envoyee";
  const subject = prop ? `Suite à notre proposition d'accompagnement — ${c.entreprise}` : `Suite à notre échange — ${c.entreprise}`;
  const montant = c.montant_estime ? ` (${fmtEUR(c.montant_estime)} HT)` : "";
  const body = [
    `Bonjour ${c.contact_nom},`, "",
    prop
      ? `Je me permets de revenir vers vous concernant la proposition d'accompagnement (${besoins}) que je vous ai adressée pour ${c.entreprise}${montant}.`
      : `Je me permets de revenir vers vous au sujet de votre projet (${besoins}) pour ${c.entreprise}.`,
    "",
    prop
      ? "Avez-vous pu en prendre connaissance ? Je reste à votre disposition pour en échanger, l'ajuster si besoin et répondre à vos questions."
      : "Souhaitez-vous que nous convenions d'un échange pour avancer ensemble sur ce sujet ?",
    "", "Bien cordialement,", "", "KARU'CARA Consulting", "Audit · Management de projet · Stratégie marketing",
  ].join("\n");
  return `mailto:${c.contact_email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

export const HEURES = Array.from({ length: 48 }, (_, i) => {
  const h = String(Math.floor(i / 2)).padStart(2, "0");
  const m = i % 2 ? "30" : "00";
  return { id: `${h}:${m}`, label: `${Number(h)} h ${m}` };
});

export const TZ_LABELS = {
  "America/Guadeloupe": "Guadeloupe (UTC−4)", "America/Martinique": "Martinique (UTC−4)", "America/Cayenne": "Guyane (UTC−3)",
  "Europe/Paris": "Paris (heure de France)", "Indian/Reunion": "La Réunion (UTC+4)",
};
